var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalonSocial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SalonSocial_White",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 82.389,
    height: 91.807,
    viewBox: "0 0 82.389 91.807",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f5f5f5;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    className: "cls-1",
    width: 82.389,
    height: 91.807
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    className: "cls-1",
    d: "M219.447,0a2.176,2.176,0,0,1,1.535,2.354c-.036,1.73.027,3.462-.023,5.192s-1.9,2.674-3.06,1.235a2.29,2.29,0,0,1-.48-1.318c-.1-1.839-.026-3.687-.038-5.532A2.1,2.1,0,0,1,218.516.124L219.447,0",
    transform: "translate(-178.331)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    className: "cls-1",
    d: "M263.072,111.332c2.579-.5,5.122-.991,7.664-1.488a4.436,4.436,0,0,1,5.538,3.6c.591,2.831-.761,5.077-3.539,5.639q-9.78,1.977-19.583,3.835a4.415,4.415,0,0,1-5.194-3.663c-.557-2.715.758-5,3.306-5.58,2.356-.532,4.737-.951,7.107-1.422.344-.068.687-.147,1.079-.231l-3.935-20.151c-5.646-.519-9.132-4.062-12-8.389a40.878,40.878,0,0,1-5.948-16.633,91.261,91.261,0,0,1-.723-22.057c.265-3.029.355-3.135,3.355-3.71q7.515-1.44,15.02-2.926c1.578-.31,2.1-.093,2.839,1.3a83.8,83.8,0,0,1,9.147,26.7c.945,6.1.694,12.158-1.775,17.946a12.854,12.854,0,0,1-5.93,6.813.811.811,0,0,0-.363.662q1.877,9.754,3.809,19.5a1.645,1.645,0,0,0,.123.261m.474-45.571a85.566,85.566,0,0,0-8.3-23.948L240.488,44.7a86.81,86.81,0,0,0,.551,21.064Zm.415,3.7H241.716a36.037,36.037,0,0,0,4.516,11.567,17.485,17.485,0,0,0,5.477,5.931,6.612,6.612,0,0,0,4.746,1.161c2.5-.451,4-2.171,5.088-4.261,2.358-4.514,2.684-9.386,2.418-14.4m8.892,45.177c0-.983-.527-1.444-1.476-1.259q-9.437,1.844-18.873,3.689c-.764.148-1.217.441-1.03,1.314.2.913.476,1.107,1.451.919q4.874-.94,9.748-1.884,4.521-.879,9.041-1.768c.584-.114,1.13-.255,1.139-1.01",
    transform: "translate(-194.022 -31.201)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    className: "cls-1",
    d: "M13.453,111.371,17.161,91.4a34.373,34.373,0,0,1-3.515-2.852c-2.668-2.8-3.83-6.346-4.51-10.061A41.2,41.2,0,0,1,9.855,61.7a89.287,89.287,0,0,1,8.259-22.14c.8-1.5,1.27-1.709,2.96-1.38q8.035,1.567,16.072,3.119c1.517.293,1.943.8,2.108,2.313a84.3,84.3,0,0,1,.316,15.026c-.459,6.6-1.3,13.133-3.933,19.283-1.9,4.437-4.351,8.5-8.3,11.464a11.962,11.962,0,0,1-5.979,2.427.968.968,0,0,0-.7.558c-1.23,6.475-2.424,12.957-3.62,19.438a1.022,1.022,0,0,0,.05.259c2.447.478,4.924.977,7.408,1.445,3.314.624,4.827,3.114,3.83,6.344a4.374,4.374,0,0,1-4.929,3.09q-9.931-1.893-19.844-3.882A4.339,4.339,0,0,1,0,114.728c.019-2.512,1.418-4.5,3.64-4.879a8.513,8.513,0,0,1,2.829.162c2.289.4,4.564.882,6.984,1.359m7.5-69.55c-4.592,9.291-8.1,18.826-8.807,29.338h1.082c6.63,0,13.261-.017,19.891.022.825.005,1.115-.251,1.283-1.03a80.154,80.154,0,0,0,1.737-16.98c0-2.8-.19-5.6-.3-8.44l-14.891-2.91M12.3,74.8c.328,3.951,1.123,7.648,3.522,10.807a6.224,6.224,0,0,0,3.806,2.5c2.322.45,4.206-.543,5.933-1.9a22.526,22.526,0,0,0,6.17-8.349c.465-.973.849-1.984,1.3-3.058ZM25.04,117.983c-.011-.562-.438-.779-1.029-.893q-9.482-1.842-18.961-3.7c-.888-.173-1.2.056-1.381.938-.164.821.075,1.143,1.012,1.326q9.437,1.839,18.876,3.672c.967.188,1.458-.221,1.482-1.338",
    transform: "translate(0 -31.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    className: "cls-1",
    d: "M178.8,8.49A2.922,2.922,0,0,1,177.631,9.7a1.355,1.355,0,0,1-1.862-.361A44.543,44.543,0,0,1,173.1,4.906a1.594,1.594,0,0,1,.755-2,1.617,1.617,0,0,1,2.123.286c.968,1.425,1.812,2.935,2.693,4.417a1.065,1.065,0,0,1,.124.883",
    transform: "translate(-141.907 -2.166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    className: "cls-1",
    d: "M257.122,4.682a15.655,15.655,0,0,1-3.14,4.89,1.43,1.43,0,0,1-1.906-.137,1.5,1.5,0,0,1-.6-1.9,50.024,50.024,0,0,1,2.686-4.421,1.491,1.491,0,0,1,1.887-.36,1.813,1.813,0,0,1,1.068,1.925",
    transform: "translate(-206.193 -2.12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    className: "cls-1",
    d: "M339.141,119.943a1.841,1.841,0,0,1-1.374,1.958,1.631,1.631,0,0,1-1.985-.985q-1.223-3.594-2.308-7.235a1.708,1.708,0,0,1,1.174-1.97,1.784,1.784,0,0,1,2.291,1.183c.685,2,1.306,4.022,1.944,6.038.125.395.207.8.259,1.011",
    transform: "translate(-273.545 -91.575)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    className: "cls-1",
    d: "M320.186,78.292a1.828,1.828,0,0,1-1.816-1.736,1.789,1.789,0,1,1,3.577-.054,1.824,1.824,0,0,1-1.762,1.789",
    transform: "translate(-261.197 -61.313)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    className: "cls-1",
    d: "M170.7,99.008c-.13,2.022-.244,4.046-.4,6.066a1.769,1.769,0,0,1-1.909,1.808,1.793,1.793,0,0,1-1.665-1.964q.116-5.406.286-10.811a1.788,1.788,0,1,1,3.569-.021c.064,1.637.016,3.278.016,4.918l.1,0",
    transform: "translate(-136.784 -75.636)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    className: "cls-1",
    d: "M162.883,193.867a1.79,1.79,0,1,1-1.611,2.547,1.792,1.792,0,0,1,1.611-2.547",
    transform: "translate(-132.169 -159.052)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalonSocial);
export default __webpack_public_path__ + "static/media/SalonSocial.9ae1e399d19db35610bb9a0ccfe34919.svg";
export { ForwardRef as ReactComponent };